
import { useState } from 'react';

export default function Services() {
  const [hoveredIndex, setHoveredIndex] = useState<number | null>(null);

  const services = [
    {
      title: 'Furniture & Appliances',
      description: 'Sofas, beds, refrigerators, washers - we haul it all with precision and care',
      icon: 'ri-sofa-line',
      image: 'https://public.readdy.ai/ai/img_res/61d2d589edba061f9c7b293df2ca0eb2.jpg'
    },
    {
      title: 'Garage & Storage Cleanouts',
      description: 'Complete cleanout services for garages, storage units, and sheds',
      icon: 'ri-home-gear-line',
      image: 'https://readdy.ai/api/search-image?query=cluttered%20garage%20full%20of%20boxes%20old%20items%20needing%20cleanout%20service%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20professional%20before%20cleanup%20photo%20modern%20industrial%20style&width=600&height=400&seq=service-tech-002&orientation=landscape'
    },
    {
      title: 'Evictions & Foreclosures',
      description: 'Professional property clearing for landlords and property managers',
      icon: 'ri-building-2-line',
      image: 'https://readdy.ai/api/search-image?query=empty%20room%20after%20property%20cleanout%20bare%20walls%20clean%20floors%20professional%20eviction%20cleanup%20service%20dark%20moody%20atmosphere%20with%20blue%20accent%20lighting%20modern%20industrial%20style&width=600&height=400&seq=service-tech-003&orientation=landscape'
    },
    {
      title: 'Bulky Items Removal',
      description: 'Large items like mattresses, couches, and oversized furniture',
      icon: 'ri-truck-line',
      image: 'https://readdy.ai/api/search-image?query=bulky%20items%20mattress%20large%20couch%20oversized%20furniture%20ready%20for%20removal%20dark%20industrial%20background%20with%20blue%20accent%20lighting%20professional%20hauling%20service%20modern%20style&width=600&height=400&seq=service-tech-004&orientation=landscape'
    },
    {
      title: 'Curbside Pickup',
      description: 'Convenient pickup service right from your curb',
      icon: 'ri-roadster-line',
      image: 'https://readdy.ai/api/search-image?query=items%20placed%20at%20curbside%20for%20pickup%20residential%20street%20view%20evening%20time%20with%20blue%20accent%20lighting%20professional%20hauling%20truck%20modern%20industrial%20style&width=600&height=400&seq=service-tech-005&orientation=landscape'
    },
    {
      title: 'Donation Pickup',
      description: 'We help you donate usable items to local charities',
      icon: 'ri-heart-3-line',
      image: 'https://readdy.ai/api/search-image?query=donation%20boxes%20filled%20with%20clothes%20household%20items%20ready%20for%20charity%20pickup%20dark%20moody%20background%20with%20blue%20accent%20lighting%20organized%20professional%20service%20modern%20style&width=600&height=400&seq=service-tech-006&orientation=landscape'
    }
  ];

  const additionalServices = [
    'Estate Cleanouts',
    'Yard Waste Removal',
    'Construction Debris',
    'Hot Tub Removal',
    'Shed Demolition',
    'Hoarding Cleanup'
  ];

  return (
    <section id="services" className="py-24 bg-gradient-to-b from-black via-gray-900 to-black relative overflow-hidden">
      {/* Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute inset-0" style={{
          backgroundImage: 'linear-gradient(rgba(6, 182, 212, 0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(6, 182, 212, 0.1) 1px, transparent 1px)',
          backgroundSize: '100px 100px'
        }}></div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="text-center mb-16">
          <span className="inline-flex items-center gap-2 text-cyan-400 text-sm font-bold tracking-[0.3em] uppercase mb-4" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            <span className="w-8 h-px bg-cyan-400"></span>
            What We Do
            <span className="w-8 h-px bg-cyan-400"></span>
          </span>
          <h2 
            className="text-5xl md:text-6xl font-black text-white mb-4"
            style={{ fontFamily: 'Orbitron, sans-serif' }}
          >
            OUR SERVICES
          </h2>
          <p className="text-xl text-gray-400" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
            Comprehensive hauling solutions powered by efficiency
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-16" data-product-shop>
          {services.map((service, index) => (
            <div
              key={index}
              className="group relative overflow-hidden rounded-lg cursor-pointer bg-gray-900/50 border border-gray-800 hover:border-cyan-500/50 transition-all duration-500"
              onMouseEnter={() => setHoveredIndex(index)}
              onMouseLeave={() => setHoveredIndex(null)}
            >
              <div className="relative w-full h-64 overflow-hidden">
                <img
                  src={service.image}
                  alt={service.title}
                  className={`w-full h-full object-cover object-top transition-all duration-700 ${hoveredIndex === index ? 'scale-110 opacity-60' : 'scale-100 opacity-40'}`}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black via-black/80 to-transparent"></div>
              </div>
              
              <div className="absolute inset-0 flex flex-col justify-end p-6">
                <div className={`w-14 h-14 rounded-lg bg-gradient-to-r from-cyan-500 to-blue-600 flex items-center justify-center mb-4 transition-all duration-500 ${hoveredIndex === index ? 'scale-110 shadow-lg shadow-cyan-500/50' : ''}`}>
                  <i className={`${service.icon} text-2xl text-white`}></i>
                </div>
                <h3 className="text-xl font-bold text-white mb-2" style={{ fontFamily: 'Rajdhani, sans-serif' }}>
                  {service.title}
                </h3>
                <p className={`text-gray-400 text-sm transition-all duration-500 ${hoveredIndex === index ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4'}`}>
                  {service.description}
                </p>
              </div>

              {/* Hover Border Effect */}
              <div className={`absolute inset-0 border-2 border-cyan-400 rounded-lg transition-opacity duration-500 ${hoveredIndex === index ? 'opacity-100' : 'opacity-0'}`}></div>
            </div>
          ))}
        </div>

        {/* Additional Services */}
        <div className="flex flex-wrap justify-center gap-3">
          {additionalServices.map((service, index) => (
            <span
              key={index}
              className="bg-gray-800/50 text-gray-300 px-6 py-3 rounded-md text-sm font-medium border border-gray-700 hover:border-cyan-500/50 hover:text-cyan-400 transition-all duration-300 cursor-pointer"
              style={{ fontFamily: 'Rajdhani, sans-serif' }}
            >
              {service}
            </span>
          ))}
        </div>
      </div>
    </section>
  );
}
